import type { AnalyticsEventPayload, AnalyticsProvider } from '@/services/analytics';
import { loadScript } from '@/utils/script.utils';

declare global {
  interface Window {
    fathom?: {
      trackPageview: (ctx?: { url?: string; referrer?: string }) => void;
      trackEvent: (name: string, data?: { _value?: number }) => void;
    };
  }
}

export class FathomAnalytics implements AnalyticsProvider {
  public readonly name = 'fathom';
  public readonly consentCategories = ['analytics'] as const;

  public init(): Promise<void> {
    return loadScript('https://cdn.usefathom.com/script.js', { 'data-site': 'CYNNAINR', 'data-auto': 'false' });
  }

  public trackPageview(path?: string): void {
    window.fathom?.trackPageview(path ? { url: path } : undefined);
  }

  public trackEvent(name: string, payload?: AnalyticsEventPayload): void {
    const value = typeof payload?._value === 'number' ? payload._value : undefined;
    if (value !== undefined) window.fathom?.trackEvent(name, { _value: value });
    else window.fathom?.trackEvent(name);
  }
}
